// extracted by mini-css-extract-plugin
export default {"tabs":"TabSelect_tabs__NaXIF","oneTab":"TabSelect_oneTab__6hMui","selectedTab":"TabSelect_selectedTab__TjvRF"};